export const state = {
  travelApplyForm: {} // 差旅申请单参数
};

export const mutations = {
  setTravelApplyForm(state, obj) {
    state.travelApplyForm = obj;
  }
};
